export function sortLinesByErrors(lines) {
  return lines.sort(
    (a, b) => {
      return b.validationErrors.length - a.validationErrors.length;
    },
    { validationErrors: [] }
  );
}
